import { cn, TopPharmacyBadge } from "@au-schein-de/au-ui-library";
import type { HTMLAttributes } from "react";

export type PharmacyPickerTopFilterBadgeProps =
	HTMLAttributes<HTMLDivElement> & {
		tone?: "brand" | "inverse";
	};

export function PharmacyPickerTopFilterBadge({
	tone = "brand",
	className,
	...props
}: PharmacyPickerTopFilterBadgeProps) {
	if (tone === "brand") {
		return <TopPharmacyBadge className={className} {...props} />;
	}
	return (
		<div
			role="img"
			aria-label="Top Pharmacy"
			data-tone="inverse"
			className={cn(
				"inline-flex h-3.5 w-6 shrink-0 items-center justify-center rounded-full bg-white px-[3px] py-[2px] text-ansay-700",
				className,
			)}
			{...props}
		>
			<svg
				aria-hidden="true"
				className="h-full w-auto"
				viewBox="0 0 15.67 6.43"
				fill="none"
				stroke="none"
				xmlns="http://www.w3.org/2000/svg"
			>
				<title>Top Pharmacy</title>
				<path
					fillRule="evenodd"
					clipRule="evenodd"
					d="M5.826 0c.669 0 1.255.137 1.76.41.503.272.896.65 1.178 1.132.281.482.422 1.041.422 1.675 0 .477-.08.913-.241 1.306a3.15 3.15 0 0 1-.688.918 3.16 3.16 0 0 1-1.061.659 3.7 3.7 0 0 1-1.37.231H3.62V0h2.206Zm-.68 5.012h.602c.276 0 .526-.038.749-.114a1.6 1.6 0 0 0 .582-.345c.164-.153.29-.342.377-.565.087-.224.131-.481.131-.771 0-.39-.077-.718-.23-.986a1.48 1.48 0 0 0-.646-.607c-.277-.136-.598-.205-.963-.205h-.602v3.593Z"
					fill="currentColor"
				/>
				<path
					d="M13.308.958a.26.26 0 0 1 .215.134l.6 1.215 1.341.194a.26.26 0 0 1 .145.443l-.973.945.23 1.336a.26.26 0 0 1-.378.274l-1.197-.631-1.2.631a.26.26 0 0 1-.378-.274l.229-1.336-.972-.945a.26.26 0 0 1 .145-.443l1.34-.194.6-1.215a.26.26 0 0 1 .253-.134Z"
					fill="currentColor"
				/>
				<path
					d="M2.481 5.053H1.87a2.7 2.7 0 0 1-.762-.116 1.77 1.77 0 0 1-.59-.35 1.6 1.6 0 0 1-.383-.575A2.08 2.08 0 0 1 0 3.228c0-.395.077-.729.233-1.001.156-.273.375-.477.656-.617.282-.138.608-.208.98-.208h.612v3.65Z"
					fill="currentColor"
				/>
			</svg>
		</div>
	);
}
